// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"727":"cce611bc","787":"20638ca7"}[chunkId] + ".chunk.js";
};